import { createIcon } from '@chakra-ui/icon'

export const TagGraphic = createIcon({
  viewBox: '0 0 16 16',
  path: (
    <g>
      <path
        d="M14.8563 7.16875L14.3938 2.28437C14.3704 2.03125 14.1688 1.83125 13.9157 1.80625L9.03134 1.34375H9.02509C8.97509 1.34375 8.93603 1.35938 8.90634 1.38906L1.58915 8.70625C1.57467 8.72071 1.56317 8.73788 1.55533 8.75678C1.54749 8.77568 1.54346 8.79594 1.54346 8.81641C1.54346 8.83687 1.54749 8.85713 1.55533 8.87603C1.56317 8.89494 1.57467 8.91211 1.58915 8.92656L7.27353 14.6109C7.30321 14.6406 7.34228 14.6562 7.38446 14.6562C7.42665 14.6562 7.46571 14.6406 7.4954 14.6109L14.8126 7.29375C14.8438 7.26094 14.8595 7.21562 14.8563 7.16875ZM7.3829 13.0422L3.1579 8.81719L9.40321 2.57188L13.2626 2.9375L13.6282 6.79688L7.3829 13.0422ZM10.8251 4C10.0673 4 9.45009 4.61719 9.45009 5.375C9.45009 6.13281 10.0673 6.75 10.8251 6.75C11.5829 6.75 12.2001 6.13281 12.2001 5.375C12.2001 4.61719 11.5829 4 10.8251 4ZM10.8251 5.875C10.5485 5.875 10.3251 5.65156 10.3251 5.375C10.3251 5.09844 10.5485 4.875 10.8251 4.875C11.1017 4.875 11.3251 5.09844 11.3251 5.375C11.3251 5.65156 11.1017 5.875 10.8251 5.875Z"
        fill="#2D3748"
      />
    </g>
  ),
})
